import React, { useState, useEffect } from "react";
import { MdArrowDropDown, MdArrowDropUp } from "react-icons/md";
import { Link, useNavigate, Outlet } from "react-router-dom";
import "../pages/all css/subdropdown.css";

function SingleDropDown({ colorChange, fromPage }) {
  const [showDropDown, setShowDropDown] = useState(false);
  const [dropDownButton, setDropDownButton] = useState("");
  const [clicked, setClicked] = useState(false);
  const [careerFlag, setCareerFlag] = useState(false);
  const [bookFlag, setBookFlag] = useState(false);
  const [counsellingFlag, setCounsellingFlag] = useState(false);

  const navigate = useNavigate();

  const handleShowDropDown = () => {
    console.log("line 9");
  };

  const handleCloseDropDown = (data) => {
    console.log(data);
    setClicked(!clicked);
    setDropDownButton(data);

    setShowDropDown(!showDropDown);
  };

  //   const handleBlogDropDown = () => {
  //     setShowDropDown(false);
  //     window.open("https://ielts.dynamicwec.net");
  //   };
  return (
    <li
      className={
        showDropDown ? "drop_down_container_li" : "drop_down_container_li1"
      }
    >
      <div className="dropdown1">
        <button
          className={
            colorChange || fromPage !== "home"
              ? "nav_change_color_text bg_transp"
              : "nav_link_text buton_nav"
          }
          onClick={() => setShowDropDown(!showDropDown)}
        >
          DWEC Academy
          {showDropDown ? (
            <MdArrowDropUp className="drop_down_btn" />
          ) : (
            <MdArrowDropDown className="drop_down_btn" />
          )}
        </button>

        {showDropDown ? (
          <div className="dropdown-content" onMouseLeave={handleCloseDropDown}>
            <button
              className={
                bookFlag
                  ? "nav_link_under_text nav_link main_text_title "
                  : "nav_link_under_text nav_link main_text_title  "
              }
              onClick={() => {
                setBookFlag(!bookFlag);
                window.open("https://ielts.dynamicwec.net/", "_blank");
              }}
            >
              IELTS
            </button>

            <button
              className={
                careerFlag
                  ? "nav_link_under_text nav_link main_text_title up_chevron"
                  : "nav_link_under_text nav_link main_text_title down_chevron  "
              }
              onClick={() => setCareerFlag(!careerFlag)}
            >
              German Language
            </button>
            {careerFlag ? (
              <>
                {" "}
                <button
                  id="studyabroad"
                  className="nav_link_under_text text_indent_text nav_link"
                  onClick={() => window.open("")}
                >
                  Coming Soon
                </button>
              </>
            ) : null}
          </div>
        ) : null}
      </div>
    </li>
  );
}

export default SingleDropDown;
